module.exports = __webpack_public_path__ + "img/220-22e281.png";